import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MeasurementDetailComponent } from './measurement-detail.component';

const routes: Routes = [
  {
    path: '',
    component: MeasurementDetailComponent,
    data: {
      title: 'Measurement Detail',
      urls: [
        { title: 'Dashboard', url: '/' },
        { title: 'Measurements', url: '/measurements' },
        { title: 'Measurement Detail' },
      ],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MeasurementDetailRoutingModule {}
